// The server config is static per deployment, so cache the first successful
// fetch and hand the same result to every caller (app startup, header, upload
// form, boosting selector, success notification) instead of refetching. A
// failed attempt is not cached, so callers can retry.
let cachedConfig: Promise<any> | null = null;

export const getServerConfig = async (
  timeoutMs: number = 10000,
): Promise<any> => {
  if (cachedConfig) {
    return cachedConfig;
  }

  const request = (async () => {
    const response = await fetch(`/serverconfig/`, {
      method: "GET",
      signal: AbortSignal.timeout(timeoutMs),
    });
    if (!response.ok) {
      throw new Error("Network response was not ok: " + response.statusText);
    }
    return await response.json();
  })();

  cachedConfig = request;
  // Don't cache failures -- clear so the next caller retries.
  request.catch(() => {
    cachedConfig = null;
  });

  return request;
};
